export var isColorProp = function (prop) { return ['fill', 'stroke', 'fillStyle', 'strokeStyle'].includes(prop); };
export var isGradientColor = function (val) { return /^[r,R,L,l]{1}[\s]*\(/.test(val); };
//# sourceMappingURL=color.js.map